import { render, staticRenderFns } from "./ISFDetailResponse.vue?vue&type=template&id=568c7e7b&"
import script from "./ISFDetailResponse.vue?vue&type=script&lang=js&"
export * from "./ISFDetailResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports